import React from "react";
import { socials } from "../../data/profile";
import { getSocialIcon } from "../../lib/icons";

/**
 * Renders the social profiles that actually have a URL. Entries with a `null`
 * url are skipped so the page never shows a dead link.
 */
function SocialLinks({ variant = "full" }) {
  const available = socials.filter((social) => Boolean(social.url));

  if (available.length === 0) {
    return null;
  }

  return (
    <ul className="social-row">
      {available.map((social) => {
        const Icon = getSocialIcon(social.id);
        return (
          <li key={social.id}>
            <a
              className="social-link"
              href={social.url}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={social.label}
            >
              <Icon aria-hidden="true" />
              {variant === "full" && <span>{social.label}</span>}
            </a>
          </li>
        );
      })}
    </ul>
  );
}

export default SocialLinks;
